<template>
  <section class="user-registration-container p-4">

    <!-- User Registration Form -->
    <form @submit.prevent="submitForm" class="form-container py-4">
      <div class="text-center mb-4">
        <h1 class="text-primary">تسجيل مستخدم جديد</h1>
      </div>
      <div class="row mb-3">
        <div v-for="field in formFields" :key="field.id" class="col-md-6 mb-2">
          <label :for="field.id" class="form-label">{{ field.label }}</label>
          <select v-if="field.type == 'select'" class="form-select" :id="field.id" v-model="field.value"
            :required="field.required" :disabled="field.disabled ?? isDisabled">
            <option value="" data-hidden="true" :selected="(field.value) ? false : true" disabled>{{ field.placeholder
              }}
            </option>
            <option v-for="option in field.options" :key="option.id" :value="option.id">
              {{ option[field.optionName] }}
            </option>
          </select>
          <input v-else :type="field.type" class="form-control" :id="field.id" v-model="field.value"
            :required="field.required" :disabled="field.disabled ?? isDisabled" />
        </div>
      </div>
      <!-- Submit Button -->
      <button type="submit" class="btn btn-primary w-100">
        تسجيل المستخدم
      </button>
    </form>

  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import router from '@/router';
export default {
  data() {
    return {
      formFields: {
        firstName: { id: 'firstName', label: 'الاسم الأول', type: 'text', value: "" },
        lastName: { id: 'lastName', label: 'اللقب', type: 'text', value: "" },
        phoneNo: { id: 'phoneNo', label: 'رقم الهاتف', type: 'text', value: "" },
        email: { id: 'email', label: 'البريد الإلكتروني', type: 'email', value: "" },
        pass: { id: 'pass', label: 'الرقم السري', type: 'password', value: "" },
        repeatPass: { id: 'repeatPass', label: 'أعد الرقم السري', type: 'password', value: "" },
        empNo: { id: 'empNo', label: 'الرقم الوظيفي', type: 'text', value: "" },
        departId: {
          id: "departId",
          label: "القسم",
          type: 'select',
          value: "",
          options: [],
          optionName: "name",
          placeholder: "مركز الجمرك الحدودي",
        },
        groupId: {
          id: "groupId",
          label: "الوظيفة",
          type: 'select',
          value: "",
          options: [],
          optionName: "groupName",
          placeholder: "الصفة الوظيفية",
        },
      },

      alert: null, // Object to hold alert messages
    };
  },
  created() {
    this.fetchAllOptions();
  },
  computed: {
    ...mapGetters(['getDeparts', 'getGroups', 'getUser'])
  },
  methods: {
    /** */
    ...mapActions([
      'fetchDeparts',
      'fetchGroups',
      'fetchUser',
    ]),
    /********************************/

    /** */
    async fetchAllOptions() {

      if (this.getDeparts.length == 0) {
        await this.fetchDeparts();
      }
      if (this.getGroups.length == 0) {
        await this.fetchGroups();
      }
      if (this.getUser.hasOwnProperty("empNo") == 0) {
        await this.fetchUser();
      }

      this.formFields.departId.options = this.getDeparts;
      this.formFields.groupId.options = [ ...this.getGroups]; //to pass an array by value
      if (this.getUser.groupId != 1) {
        this.formFields.groupId.options.shift();
      }

    },
    /***********************/

    // Form submission method
    async submitForm() {
      // Basic form validation
      if (this.formFields.pass.value !== this.formFields.repeatPass.value) {
        this.$tempAlert("كلمة المرور غير متطابقة!", "danger");
        return;
      }

      if (!this.formFields.firstName.value || !this.formFields.lastName.value || !this.formFields.phoneNo.value || !this.formFields.pass.value || !this.formFields.groupId.value) {
        this.$tempAlert("يرجى ملء جميع الحقول المطلوبة!", "danger");
        return;
      }
      const formData = new FormData();
      // const reqData ={}
      Object.keys(this.formFields).forEach((key) => {
        if (key != "repeatPass") {
          formData.append(key, this.formFields[key].value);
          // reqData[key] = this.formFields[key].value
        }
      });

      try {
        const response = await this.$axios.post("api/employee/user/register", formData);
        if (response.data.isSuccess) {
          this.$tempAlert(response.data.msg ?? "تمت الإضافة بنجاح", "success");
          setTimeout(()=>{
            this.$router.push({ name: "Privileges" });
          },1000)
        } else {
          this.$tempAlert(response.data.msg ?? "فشل العملية");
        }
      } catch (error) {
        if (error.response?.data) {
          this.$tempAlert(error.response.data.msg, 'warning');
          var emsg = {
            msg: "",
            interval: 4000
          };
          error.response.data?.errors.forEach((e) => {
            emsg.msg += e + "<br/>";
            emsg.interval += 2000;
          })
          setTimeout(() => {
            this.$tempAlert(emsg.msg, 'warning', emsg.interval);
          }, 1000)
        }
        console.error("Submission error:", error);
      }
    },

    // Reset the form after successful submission
    resetForm() {
      this.formFields = {
        firstName: "",
        lastName: "",
        phoneNo: "",
        pass: "",
        repeatPass: "",
        groupId: "",
        profileImage: null,
      };
    },
  },
};
</script>

<style scoped>
.form-container {
  max-width: 800px;
  margin: 0 auto;
}

.alert {
  margin-top: 20px;
}

.btn {
  padding: 12px;
  font-size: 16px;
}
</style>